/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Time from 'fierry/util/time';


const SERVER_DELAY_MAX = 5 * Time.getSecondTicks();


export default class
{
  constructor (state)
  {
    this.state = state.get('currentTime');
  }


  getClientDate (now)
  {
    return now ? new Date(now - this.state.client_delay) : this.state.client_date;
  }


  getServerDate (now)
  {
    return now ? new Date(now - this.state.server_delay) : this.state.server_date;
  }


  isRealTime ()
  {
    return this.state.realtime === true;
  }


  isServerDelayed ()
  {
    return this.getServerDelay() >= SERVER_DELAY_MAX;
  }


  getServerDelay ()
  {
    return this.getClientDate() - this.getServerDate();
  }



};
